export default "__VITE_ASSET__BkkNwI98__"